import React, { useContext, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import { StoreContext } from "../../context/StoreContext";

const AddButton = ({ qty, add, remove }) => {
  const { data } = useContext(StoreContext);
  const storeDetails = data.store_master;
  const [addAnimate, setAddAnimate] = useState(false);
  const [removeAnimate, setRemoveAnimate] = useState(false);
  const [clicked, setClicked] = useState(null);

  const triggerAnimation = (type, callback) => {
    setClicked(type);
    callback();
    setTimeout(() => setClicked(null), 200);
  };

  const handleAdd = () => {
    add();
    setRemoveAnimate(true);
    setTimeout(() => {
      setRemoveAnimate(false);
    }, 250);
  };

  const handleRemove = () => {
    remove();
    setAddAnimate(true);
    setTimeout(() => {
      setAddAnimate(false);
    }, 250);
  };

  return (
    <>
      {qty === 0 ? (
        <div
          // className={`btn-div ${isListView ? 'listview' : ''}`}
          className="btn-div listview"
          onClick={handleAdd}
          style={{
            color: ' #FF3010'
          }}
        >
          <span>Add</span>
        </div>
      ) : (
        <div
          className="increment-btn listview"
        //className={`increment-btn ${isListView ? 'listview' : ''}`}
        >
          <div className="add-icon" onClick={() => triggerAnimation("minus", handleRemove)} style={{
            flex: 1,
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            backgroundColor: clicked === "minus" ? "#ffe5e0" : "transparent",
            transition: "background-color 0.3s ease",
            borderRadius: '50%',
            margin: "4px",
          }}>
            <FaMinus />
          </div>
          <div className="p-qty" style={{
            flex: 1,
            textAlign: "center",
            color: "#FF3010",
            fontWeight: 500,
          }}>{qty}</div>
          <div className="add-icon" onClick={() => triggerAnimation("plus", handleAdd)} style={{
            flex: 1,
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            backgroundColor: clicked === "plus" ? "#e0f7e9" : "transparent",
            borderRadius: "50%", 
            margin: "4px",       
            transition: "background-color 0.3s ease",
          }}>
            <FaPlus />
          </div>
          {addAnimate && (
            <div
              className="add-loader-slider"
              style={{ background: storeDetails[0].primarycolorcode }}
            ></div>
          )}
          {removeAnimate && (
            <div
              className="remove-loader-slider"
              style={{ background: storeDetails[0].primarycolorcode }}
            ></div>
          )}
        </div>
      )}
    </>
  );
};

export default AddButton;